import React, { ChangeEvent, Component, ReactNode } from "react";
import classnames from "classnames";
import { observer } from "mobx-react";

import { HStack } from "@formant/ui/component/common/HStack";

import * as styles from "./RadioOption.scss";

export interface IRadioOptionProps {
    id: string;
    name?: string;
    value: string;
    checked: boolean;
    disabled?: boolean;
    className?: string;
    extraLabel?: ReactNode;
    onChange: (value: string) => void;
    children?: React.ReactNode;
}

@observer
export class RadioOption extends Component<IRadioOptionProps> {
    public render() {
        const {
            id,
            name,
            value,
            checked,
            disabled,
            children,
            extraLabel,
            className,
        } = this.props;

        return (
            <HStack
                className={classnames(
                    styles["radio-option"],
                    checked && styles.checked,
                    disabled && styles.disabled,
                    className,
                )}
                vAlign="center"
            >
                <HStack
                    vAlign="center"
                    hAlign="center"
                    className={styles.radio}
                >
                    <input
                        type="radio"
                        id={id}
                        name={name}
                        value={value}
                        checked={checked}
                        disabled={disabled}
                        onChange={this.onChange}
                    />
                </HStack>

                {children && (
                    <label htmlFor={id} className={styles.label}>
                        {children}
                    </label>
                )}

                {extraLabel}
            </HStack>
        );
    }

    private onChange = (event: ChangeEvent<HTMLInputElement>) => {
        this.props.onChange(event.target.value);
    };
}
